<div class="inner-card d-flex flex-column gap-3">
  <div class="d-flex justify-content-between align-items-start">
    <div class="d-flex flex-column gap-2">
      <div class="title-sm">
        <span *ngIf="card.isMonthly" i18n>Monthly Payments</span>
        <span *ngIf="!card.isMonthly" i18n>Annual Payments</span>
      </div>
      <div *ngIf="card.subtext" class="card-subtext">{{ card.subtext }}</div>
    </div>
    <app-status-pill *ngIf="showStatusPill" [statusPill]="card.statusPill" />
  </div>

  <div class="d-flex flex-column gap-3">
    <ng-container *ngFor="let row of card.rows; let last = last">
      <div class="payment-row">
        <div class="paragraph-lg">{{ row.jurisdictionName }}</div>
        <div class="amount-cell">
          <div class="row-amount">
            <span>{{ row.amount | currency }}</span
            ><span *ngIf="card.isMonthly" i18n class="period"> /mo</span
            ><span *ngIf="!card.isMonthly" i18n class="period"> /yr</span>
          </div>
          <div class="payment-type-label">{{ row.paymentTypeLabel }}</div>
        </div>
      </div>
      <hr *ngIf="!last" class="m-0" />
    </ng-container>
  </div>
  <hr class="m-0" />
  <div class="d-flex flex-column gap-2">
    <div class="payment-row">
      <span i18n class="title-sm">Estimated Recurring Payments Total:</span>
      <div class="total-amount">
        <span>{{ card.total | currency }}</span
        ><span *ngIf="card.isMonthly" i18n class="period"> /mo</span
        ><span *ngIf="!card.isMonthly" i18n class="period"> /yr</span>
      </div>
    </div>
    <div *ngIf="card.isMonthly" class="payment-row">
      <span i18n class="annual-total-label">Est. Recurring Payments Annual Total</span>
      <div class="annual-total-value">
        <span>{{ card.annualTotal | currency }}</span>
        <span i18n> /yr</span>
      </div>
    </div>
  </div>
</div>
